/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

if (isTouchDevice) {
  document.querySelector("body").classList.add("is-touch");
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added):not(.pill)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-thin, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkClone = el.cloneNode(true);
      linkClone.querySelectorAll(".visuallyhidden").forEach(hiddenText => hiddenText.remove());
      const hiddenTextNodes = el.querySelectorAll(".visuallyhidden");
      const linkHTML = "<span class='linkline'>" + linkClone.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
      hiddenTextNodes.forEach(hiddenText => {
        el.append(hiddenText);
      });
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      const accordionItem = item.closest(".accordion__item");
      accordionItem.classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      const isOpen = accordionItem.classList.contains("accordion__item--open");
      this.setAttribute("aria-expanded", isOpen ? "true" : "false");
      var panel = accordionItem.querySelector(".accordion__answer");
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );
  window.addEventListener("resize", function () {
    accordionItems.forEach(function (item) {
      if (item.closest(".accordion__item").classList.contains("accordion__item--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// const plyrsInit = function () {
//   const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

//   if (!plyrs) {
//     return;
//   }

//   plyrs.forEach(function (el) {
//     let plyr = el.querySelector(".mediavideo__video");
//     new Plyr(plyr, {
//       controls: ["play", "progress", "mute", "current-time"],
//       hideControls: true,
//       invertTime: false,
//       tooltips: { controls: false, seek: false }
//     });
//   });
// }; // plyrsInit();

// plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink--popup");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    showClass: "f-slideInRight",
    hideClass: "f-slideOutRight",
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false, // Disable thumbnails
    Html: {
      vimeo: {
        color: "3D2CEB" // hex without #
      }
    }
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    GENERAL - Hover list
    ========================================================================== */

const serviceLists = document.querySelectorAll(".service__list");

const serviceListsInit = function (lists) {
  if (!lists || !lists.length) {
    return;
  }

  lists.forEach(function (list) {
    const toggle = list.querySelector("[data-service-toggle]");
    if (!toggle) {
      return;
    }
    const toggleText = toggle.querySelector("[data-service-toggle-text]") || toggle;
    const serviceItems = list.querySelectorAll(".service__item");
    const getVisibleLimit = function () {
      return window.matchMedia("(min-width: 550px)").matches ? 8 : 4;
    };

    const updateServiceListState = function (expanded) {
      const visibleLimit = getVisibleLimit();
      serviceItems.forEach(function (item, index) {
        const link = item.querySelector("a");
        const isHidden = !expanded && index >= visibleLimit;
        item.setAttribute("aria-hidden", isHidden ? "true" : "false");
        if (link) {
          if (isHidden) {
            link.setAttribute("tabindex", "-1");
          } else {
            link.removeAttribute("tabindex");
          }
        }
      });
    };

    // Ensure initial state is collapsed
    list.classList.remove("is-expanded");
    toggle.setAttribute("aria-expanded", "false");
    toggleText.textContent = "Show more";
    updateServiceListState(false);

    toggle.addEventListener("click", function () {
      const expanded = list.classList.toggle("is-expanded");
      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      toggleText.textContent = expanded ? "Show less" : "Show more";
      updateServiceListState(expanded);
      if (expanded) {
        const firstRevealedItem = serviceItems[getVisibleLimit()];
        const firstRevealedLink = firstRevealedItem ? firstRevealedItem.querySelector("a") : false;
        if (firstRevealedLink) {
          firstRevealedLink.focus();
        }
      }
    });

    window.addEventListener("resize", function () {
      updateServiceListState(list.classList.contains("is-expanded"));
    });
  });
};

serviceListsInit(serviceLists);

/*  ==========================================================================
    GENERAL - Hover list
    ========================================================================== */

const hoverListItems = document.querySelectorAll(".hover__item .item__heading");

const hover__itemInit = function (hover__itemItems) {
  if (!hover__itemItems) {
    return;
  }

  let count = 0;
  hover__itemItems.forEach(item => {
    const toggleLeader = function (item) {
      const parent = item.closest(".module");
      const listTarget = item.getAttribute("data-target");

      if (!listTarget) {
        return;
      }

      let selector = ".leaders__leader";
      let activeLeader = parent.querySelector(`.leaders__leader[data-index="desktop-${listTarget}"]`);

      parent.querySelectorAll(selector).forEach(leader => {
        leader.style.maxHeight = "0px";
        leader.style.opacity = "0";
        leader.classList.remove("leaders__leader--active");
      });

      parent.querySelectorAll(".item__heading--active").forEach(heading => {
        heading.classList.remove("item__heading--active");
      });

      const container = parent.querySelector(".hover-list__leaders");
      container.style.minHeight = activeLeader.scrollHeight + "px";

      if (activeLeader.style.maxHeight && activeLeader.style.maxHeight !== "0px") {
        activeLeader.style.maxHeight = "0px";
        activeLeader.style.opacity = "0";
        activeLeader.classList.remove("leaders__leader--active");
        item.classList.remove("item__heading--active");
      } else {
        activeLeader.style.maxHeight = activeLeader.scrollHeight + "px";
        activeLeader.style.opacity = "1";
        activeLeader.classList.add("leaders__leader--active");
        item.classList.add("item__heading--active");
      }
    };

    item.addEventListener("mouseenter", function () {
      // hover for desktop
      if (!isTouchDevice) {
        toggleLeader(item);
      }
    });

    item.addEventListener("click", function (e) {
      e.preventDefault();
      // click for mobile
      if (isTouchDevice) {
        toggleLeader(item);
      }
    });

    if (count === 0) {
      // first item, so force this to show ahead of mouseenter
      if (isTouchDevice) {
        console.log("show first");
        toggleLeader(item);
      }
    }
    count++;
  });

  window.addEventListener("resize", function () {
    hover__itemItems.forEach(item => {
      const parent = item.closest(".module");
      let activeLeader = parent.querySelector(`.leaders__leader--active`);
      const container = parent.querySelector(".hover-list__leaders");
      if (activeLeader) {
        container.style.minHeight = activeLeader.scrollHeight + "px";
      }
    });
  });
}; // hover__itemInit();
hover__itemInit(hoverListItems);

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.innerHTML; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.innerHTML = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
		Check Scroll
		========================================================================== */
let oldScrollY = 0;
const siteheader = document.querySelector(".siteheader");

function checkScroll() {
  if (!siteheader) {
    return;
  }

  if (window.scrollY > 50) {
    siteheader.classList.add("siteheader--scrolled");
  } else {
    siteheader.classList.remove("siteheader--scrolled");
  }

  oldScrollY = window.scrollY;
}

// Listen for scroll
window.addEventListener("scroll", checkScroll);

// Run on load
checkScroll();

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(
  ".row--carousel .owl-carousel:not(.quotes__carousel,.quotes-text__carousel)"
);

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);
    const parent = elem.closest(".module");

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    let customNav = elem.dataset.customnav ? elem.dataset.customnav : false;

    if (customNav) {
      customNav = parent.querySelector(customNav);
    }
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    var owlCarousel = $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: [
        "<span class='visuallyhidden'>Previous slide</span><i class='fa-sharp fa-arrow-left' aria-hidden='true'></i>",
        "<span class='visuallyhidden'>Next slide</span><i class='fa-sharp fa-arrow-right' aria-hidden='true'></i>"
      ],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      navContainer: customNav,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const featuredCarousels = document.querySelectorAll(".featured__carousel .owl-carousel");

const featuredCarouselsInit = function (featuredCarousels) {
  if (featuredCarousels.length <= 0) {
    return;
  }

  featuredCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const parent = elem.closest(".module");

    // Optional data attribute settings
    let customNav = elem.dataset.customnav ? elem.dataset.customnav : false;
    let customNavElem = false;

    if (customNav) {
      customNavElem = parent.querySelector(customNav);
    }

    // tiles per row
    let tilesPerRow = elem.dataset.tilesperrow ? Number(elem.dataset.tilesperrow) : 1;

    var owlCarousel = $(elem).owlCarousel({
      autoplay: false,
      loop: false,
      nav: true,
      dots: false,
      items: 1,
      navText: [
        "<span class='visuallyhidden'>Previous slide</span><i class='fa-sharp fa-arrow-left' aria-hidden='true'></i>",
        "<span class='visuallyhidden'>Next slide</span><i class='fa-sharp fa-arrow-right' aria-hidden='true'></i>"
      ],
      startPosition: slides.length,
      autoHeight: false,
      navContainer: customNavElem,
      responsive: {
        0: {
          items: 1 // always one on mobile for this type of carousel
        },
        1000: {
          items: tilesPerRow
        }
      },
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // featuredCarouselsInit();
featuredCarouselsInit(featuredCarousels);

/*  ==========================================================================
			Quotes Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const quoteCarousels = document.querySelectorAll(".row--carousel .quotes__carousel");

const quoteCarouselInit = function (quoteCarousels) {
  if (quoteCarousels.length <= 0) {
    return;
  }

  quoteCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const parent = elem.closest(".module");

    $(elem).on("initialized.owl.carousel", function (event) {
      var numberOfSlides = event.item.count;
      var currentSlide = event.item.index - 1;

      if (numberOfSlides > 4) {
        currentSlide = event.item.index - 2;
      }

      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 1000);
    });

    var owlCarousel = $(elem).owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      items: 1,
      touchDrag: false,
      mouseDrag: false,
      navText: [
        "<span class='visuallyhidden'>Previous slide</span><i class='fa-sharp fa-arrow-left' aria-hidden='true'></i>",
        "<span class='visuallyhidden'>Next slide</span><i class='fa-sharp fa-arrow-right' aria-hidden='true'></i>"
      ],
      startPosition: slides.length,
      autoHeight: false,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });

    const quotesText = parent.querySelector(".quotes-text__carousel");

    $(elem).on("click", ".owl-next", function () {
      $(quotesText).trigger("next.owl.carousel");
      lazyLoadInstance.update();
    });

    $(elem).on("click", ".owl-prev", function () {
      $(quotesText).trigger("prev.owl.carousel");
      lazyLoadInstance.update();
    });
  });
}; // quoteCarouselInit();
quoteCarouselInit(quoteCarousels);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const quoteTextCarousels = document.querySelectorAll(".row--carousel .quotes-text__carousel");

const quoteTextCarouselInit = function (quoteTextCarousels) {
  if (quoteTextCarousels.length <= 0) {
    return;
  }

  quoteTextCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    var owlCarousel = $(elem).owlCarousel({
      loop: true,
      nav: false,
      dots: false,
      touchDrag: false,
      mouseDrag: false,
      items: 1,
      startPosition: slides.length,
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      autoHeight: true,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // quoteTextCarouselInit();
quoteTextCarouselInit(quoteTextCarousels);

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
      mobnavToggle.setAttribute("aria-expanded", "true");
    } else {
      // IT'S OPEN...
      body.classList.remove(mobnavOpenclass);
      mobnavToggle.setAttribute("aria-expanded", "false");
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__link--dropdowntrigger");
const sitenavDropdown = document.querySelector(".mobnav .sitenav__dropdown");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  const backButtons = document.querySelectorAll(".dropdown__back");

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();

      const navTarget = mobnavLink.getAttribute("data-nav-target");
      const nextPanel = sitenavDropdown.querySelector(`[data-nav-id="${navTarget}"]`);

      mobnavLinks.forEach(link => link.setAttribute("aria-expanded", "false"));
      mobnavLink.setAttribute("aria-expanded", "true");
      nextPanel.classList.add("dropdown--active");
      const firstFocusable = nextPanel.querySelector(
        "button, a, input, select, textarea, [tabindex]:not([tabindex='-1'])"
      );
      if (firstFocusable) {
        firstFocusable.focus();
      }

      backButtons.forEach(function (backButton) {
        backButton.addEventListener("click", function (e) {
          nextPanel.classList.remove("dropdown--active");
          mobnavLink.setAttribute("aria-expanded", "false");
          mobnavLink.focus();
        });
      });
    });
  });

  const dropdownAccordion = document.querySelectorAll(".accordion__heading");

  dropdownAccordion.forEach(item =>
    item.addEventListener("click", function () {
      const accordionItem = item.closest(".dropdown__accordion");
      accordionItem.classList.toggle("dropdown__accordion--open");
      item.setAttribute(
        "aria-expanded",
        accordionItem.classList.contains("dropdown__accordion--open") ? "true" : "false"
      );
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );
  window.addEventListener("resize", function () {
    dropdownAccordion.forEach(function (item) {
      if (item.closest(".dropdown__accordion").classList.contains("dropdown__accordion--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") {
      return;
    }
    const activePanel = sitenavDropdown.querySelector(".dropdown--active");
    if (activePanel) {
      const activeTrigger = document.querySelector(`[data-nav-target="${activePanel.getAttribute("data-nav-id")}"]`);
      activePanel.classList.remove("dropdown--active");
      if (activeTrigger) {
        activeTrigger.setAttribute("aria-expanded", "false");
        activeTrigger.focus();
      }
    } else if (body.classList.contains(mobnavOpenclass)) {
      body.classList.remove(mobnavOpenclass);
      mobnavToggle.setAttribute("aria-expanded", "false");
      mobnavToggle.focus();
    }
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/* ==========================================================================
   NAVIGATION - Services dropdown (hover to activate + moving indicator)
   ========================================================================== */

const dropdowns = document.querySelectorAll(".dropdown__services");

const serviceDropdownInit = function () {
  if (!dropdowns.length) {
    return;
  }

  dropdowns.forEach(dropdown => {
    const serviceTypes = dropdown.querySelector(".service__types");
    const secondColumn = dropdown.querySelector(".second__column-wrapper");
    const panels = dropdown.querySelectorAll(".column-child");
    const serviceType = dropdown.querySelectorAll(".service__type");
    const focusableSelector = "a, button, input, select, textarea, [tabindex]:not([tabindex='-1'])";
    const getPanelFocusable = panel => Array.from(panel.querySelectorAll(focusableSelector));

    const initialPanel = secondColumn.querySelector(".column-child.service__type--active") || panels[0];

    if (initialPanel) {
      secondColumn.style.height = `${initialPanel.scrollHeight}px`;
      secondColumn.style.height = "auto";
    }

    const updatePanelTabOrder = activePanel => {
      panels.forEach(panel => {
        const isActive = panel === activePanel;
        panel.setAttribute("aria-hidden", isActive ? "false" : "true");
        getPanelFocusable(panel).forEach(item => {
          item.setAttribute("tabindex", isActive ? "0" : "-1");
        });
      });
    };

    const setActive = (targetId, hoveredItem) => {
      const nextPanel = secondColumn.querySelector(`.column-child[data-id="${targetId}"]`);
      const currentPanel = secondColumn.querySelector(".column-child.service__type--active");

      if (hoveredItem) {
        const containerRect = serviceTypes.getBoundingClientRect();
        const itemRect = hoveredItem.getBoundingClientRect();
        const top = itemRect.top - containerRect.top;
        const itemHeight = itemRect.height;
        serviceTypes.style.setProperty("--indicator-top", `${top}px`);
        serviceTypes.style.setProperty("--indicator-height", `${itemHeight}px`);
      }

      const startHeight = currentPanel ? currentPanel.scrollHeight : secondColumn.scrollHeight;
      secondColumn.style.height = `${startHeight}px`;

      serviceType.forEach(el => {
        el.classList.remove("service__type--active");
        el.setAttribute("aria-selected", "false");
      });
      panels.forEach(el => {
        el.classList.remove("service__type--active");
      });

      const nextType = dropdown.querySelector(`.service__type[data-target="${targetId}"]`);
      nextType.classList.add("service__type--active");
      nextType.setAttribute("aria-selected", "true");
      nextPanel.classList.add("service__type--active");
      updatePanelTabOrder(nextPanel);

      secondColumn.style.height = `${nextPanel.scrollHeight}px`;
    };

    serviceTypes.addEventListener(
      "mouseover",
      e => {
        const item = e.target.closest(".service__type");
        if (!item) {
          return;
        }
        const targetId = item.getAttribute("data-target");

        setActive(targetId, item);
      },
      true
    );

    serviceTypes.addEventListener("focusin", e => {
      const item = e.target.closest(".service__type");
      if (!item) {
        return;
      }
      setActive(item.getAttribute("data-target"), item);
    });

    serviceTypes.addEventListener("click", e => {
      const item = e.target.closest(".service__type");
      if (!item) {
        return;
      }
      setActive(item.getAttribute("data-target"), item);
    });

    serviceTypes.addEventListener("keydown", e => {
      if (e.key !== "Tab" || e.shiftKey) {
        return;
      }

      const item = e.target.closest(".service__type");
      if (!item) {
        return;
      }

      const targetId = item.getAttribute("data-target");
      const panel = secondColumn.querySelector(`.column-child[data-id="${targetId}"]`);
      const panelFocusable = panel ? getPanelFocusable(panel) : [];

      if (!panelFocusable.length) {
        return;
      }

      e.preventDefault();
      setActive(targetId, item);
      panelFocusable[0].focus();
    });

    secondColumn.addEventListener("keydown", e => {
      if (e.key !== "Tab") {
        return;
      }

      const activePanel = e.target.closest(".column-child.service__type--active");
      if (!activePanel) {
        return;
      }

      const panelFocusable = getPanelFocusable(activePanel);
      const firstFocusable = panelFocusable[0];
      const lastFocusable = panelFocusable[panelFocusable.length - 1];
      const activeType = dropdown.querySelector(`.service__type[data-target="${activePanel.getAttribute("data-id")}"]`);

      if (e.shiftKey && e.target === firstFocusable && activeType) {
        e.preventDefault();
        activeType.focus();
        return;
      }

      if (!e.shiftKey && e.target === lastFocusable && activeType) {
        const nextListItem = activeType.closest("li").nextElementSibling;
        const nextType = nextListItem ? nextListItem.querySelector(".service__type") : null;

        if (nextType) {
          e.preventDefault();
          setActive(nextType.getAttribute("data-target"), nextType);
          nextType.focus();
        }
      }
    });

    const currentlyActiveItem = dropdown.querySelector(".service__type.service__type--active");
    const currentlyActiveTargetId = currentlyActiveItem.getAttribute("data-target");
    setActive(currentlyActiveTargetId, currentlyActiveItem);
  });
};

serviceDropdownInit();

/* ==========================================================================
   NAVIGATION - Desktop dropdown aria state
   ========================================================================== */

const desktopDropdownTriggers = document.querySelectorAll(".sitenav--center .sitenav__link--dropdowntrigger");

desktopDropdownTriggers.forEach(trigger => {
  const parent = trigger.closest(".sitenav__item--hasdropdown");

  trigger.addEventListener("click", function () {
    const isOpen = trigger.getAttribute("aria-expanded") === "true";
    desktopDropdownTriggers.forEach(item => item.setAttribute("aria-expanded", "false"));
    trigger.setAttribute("aria-expanded", isOpen ? "false" : "true");
  });

  parent.addEventListener("focusout", function (e) {
    if (!parent.contains(e.relatedTarget)) {
      trigger.setAttribute("aria-expanded", "false");
    }
  });
});

/*  ==========================================================================
	FORM - Trigger after Form Submission
	========================================================================== */

const triggerAfterSubmit = function () {
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    Waypoint.refreshAll();
  });
};

triggerAfterSubmit();

/*  ==========================================================================
				FILTER FUNCTIONS: Used in Stories, Initiatives, in Memoriam
				========================================================================== */

const filters = document.querySelector(".filters");
const filtersForm = document.querySelector(".filters__form");
let currentPageUrl = window.location.href.split("?")[0];
let filtersInitialLoad = true;

/*  ==========================================================================
			 filterGetFormData: Gets selected options from the filter columns
				========================================================================== */

const filterGetFormData = function () {
  let filterData = {};
  let counter = 0;

  if (filter_settings.filters) {
    filter_settings.filters.forEach(function (el) {
      let checkedOptions = document.querySelectorAll("input[name='" + el.name + "']:checked");
      if (checkedOptions.length > 0) {
        filterData[el.name] = [...checkedOptions].map(x => x.value);

        counter = counter + checkedOptions.length;
      }
    });
  }

  return filterData;
};

/*  ==========================================================================
			 filterUpdateURL: Updates the url with the selected values
				========================================================================== */

const filterUpdateURL = function (filterData) {
  let url_params = "";

  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter_" + key + "=" + values;
    }
  }

  // Pagination paramters
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  if (currentPageNum && url_params === "") {
    if (url_params === "") {
      url_params = url_params + "?";
      url_params = url_params + "pagenum=" + currentPageNum;
    }
  }

  let currentPageUrl = window.location.href.split("?")[0];
  currentPageUrl = currentPageUrl + url_params;

  if (history.pushState) {
    window.history.pushState({ path: currentPageUrl }, "", currentPageUrl);
  }

  currentPageUrl = currentPageUrl;
};

/*  ==========================================================================
			 filterAddingActiveTags: Setups up the active tags in the filter bar
			========================================================================== */

const filterAddingActiveTags = function (filterData) {
  let hasClassActive = false;

  // Reset styles
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  fieldsets.forEach(set => {
    set.classList.remove("filters__fieldset--active");
  });

  const fieldsetField = document.querySelectorAll(".filters__fieldset-field");
  fieldsetField.forEach(field => {
    field.classList.remove("filters__fieldset-field--active");
  });

  // Looping throught the filterData
  Object.keys(filterData).forEach(key => {
    const values = filterData[key];

    document
      .querySelector(".filters__fieldset[data-value='" + key + "']")
      .classList.remove("filters__fieldset--active");

    if (values.length > 0) {
      values.forEach(value => {
        // Make input field active
        let filter_input = document
          .querySelector("input[name='" + key + "'][value='" + value + "']")
          .closest(".filters__fieldset-field");

        filter_input.classList.add("filters__fieldset-field--active");

        hasClassActive = true;

        // Add filter name to select heading
        const fieldset = filter_input.closest(".filters__fieldset");
        if (fieldset) {
          const heading = fieldset.querySelector(".filters__fieldset-heading");
          const labelText = filter_input.querySelector(".field__label").textContent.trim();

          if (heading) {
            if (labelText) {
              heading.querySelector(".filters__fieldset-toggle span").textContent =
                heading.getAttribute("data-legendselected") + ": " + labelText;
            } else {
              heading.querySelector(".filters__fieldset-toggle span").textContent = heading.getAttribute("data-legend");
            }
          }

          fieldset.classList.remove("filters__fieldset--open");
          const toggle = fieldset.querySelector(".filters__fieldset-toggle");
          if (toggle) {
            toggle.setAttribute("aria-expanded", "false");
          }
        }

        // close select
        if (fieldset) {
          fieldset.classList.remove("filters__fieldset--open");
          const toggle = fieldset.querySelector(".filters__fieldset-toggle");
          if (toggle) {
            toggle.setAttribute("aria-expanded", "false");
          }
        }
      });
    }
  });

  return hasClassActive;
};

/*  ==========================================================================
			 filterGetPosts: Calls the ajax function that retrieve the posts that match
			 the selected filters
				========================================================================== */

const filterGetPosts = function (updateURL = false) {
  // Getting the forma data
  let filterData = filterGetFormData();
  if (filterData) {
    // Update url
    if (updateURL) {
      filterUpdateURL(filterData);
    }

    let activeTagsNotEmpty = filterAddingActiveTags(filterData);

    // Hide clear if no filters
    if (!activeTagsNotEmpty) {
      document.querySelector(".filters__clear").style.display = "none";
    }

    if ((filtersInitialLoad && activeTagsNotEmpty) || !filtersInitialLoad) {
      filtersInitialLoad = false;

      if (document.querySelector(".filters-pin")) {
        const pin = document.querySelector(".filters-pin");
        const header = document.querySelector(".siteheader");
        const headerHeight = header.offsetHeight;
        const top = pin.getBoundingClientRect().top + window.pageYOffset - headerHeight;

        window.scrollTo({
          top: top,
          behavior: "smooth"
        });
      }

      // Show "clear" button as filters are applied
      if (activeTagsNotEmpty) {
        document.querySelector(".filters__clear").style.display = "inline-block";
      }

      // Start filtering
      let loadMore = document.querySelector(".loadmore-container");
      if (loadMore) {
        document.querySelector(".loadmore-container").classList.add("filtering");
      }

      // Trigger ajax
      let data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filterData
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          // hide load more button, if there are not enough posts for the second page
          const pagingLoadmore = document.querySelector(".paging__loadmore");
          if (pagingLoadmore) {
            if (data.max_page < 2) {
              pagingLoadmore.style.display = "none";
            } else {
              pagingLoadmore.style.display = "inline-block";
            }
          }

          // insert the posts to the container
          const loadmoreContainer = document.querySelector(".loadmore-container");
          if (loadmoreContainer) {
            loadmoreContainer.innerHTML = data.content;
            // Finish filtering
            loadmoreContainer.classList.remove("filtering");
          }

          const status = document.querySelector(".filters__status");
          if (status) {
            status.textContent =
              data.max_page < 2 ? "Results updated." : "Results updated. More results are available.";
          }

          //Refreshing animations effects
          setTimeout(function () {
            Waypoint.refreshAll();
          }, 500);

          lazyLoadInstance.update();
        },
        error: function (data) {}
      });
    }
  }
};

/*  ==========================================================================
			 selectFilter: selecting the checkbox / filter
				========================================================================== */

const selectFilter = function (option) {
  // Set up for checkbox group that only admits one item checked at the time
  if (option.dataset.type && option.dataset.type === "single") {
    let name = option.getAttribute("name");

    const filterCheckboxes = document.querySelectorAll(".filters__fieldset-field input[name=" + name + "]");
    filterCheckboxes.forEach(el => {
      if (el !== option) {
        el.checked = false;
      }
    });
  }

  // Call the filtering post function
  filterGetPosts(true);
};

/*  ==========================================================================
			 clearFilters: clear filters
				========================================================================== */

const clearFilter = function (option) {
  // clear filter data
  if (filter_settings.filters) {
    filter_settings.filters.forEach(function (el) {
      let checkedOptions = document.querySelectorAll("input[name='" + el.name + "']:checked");
      if (checkedOptions.length > 0) {
        checkedOptions.forEach(el => {
          if (el !== option) {
            el.checked = false;
          }
        });
      }
    });
  }
  // Reset URL
  let currentPageUrl = window.location.href.split("?")[0];
  if (history.pushState) {
    window.history.pushState({ path: currentPageUrl }, "", currentPageUrl);
  }
  // Reset headings
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  if (fieldsets) {
    fieldsets.forEach(function (el) {
      const heading = el.querySelector(".filters__fieldset-heading");
      if (heading) {
        heading.querySelector(".filters__fieldset-toggle span").textContent = heading.getAttribute("data-legend");
      }
      el.classList.remove("filters__fieldset--open");
      const toggle = el.querySelector(".filters__fieldset-toggle");
      if (toggle) {
        toggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  // Call the filtering post function
  filterGetPosts(true);
};

/*  ==========================================================================
			 filterInit: Initialise the filtering functions when there is a filter
			 available
				========================================================================== */

const filterInit = function () {
  if (!filtersForm) {
    return;
  }

  filterGetPosts();

  const fieldsets = filters.querySelectorAll(".filters__fieldset");
  const setFieldOptionsTabIndex = function (fieldset, isOpen) {
    const options = fieldset.querySelectorAll(".filters__fieldset-field");
    options.forEach(option => {
      option.setAttribute("tabindex", isOpen ? "0" : "-1");
    });
  };

  const closeFieldset = fieldset => {
    fieldset.classList.remove("filters__fieldset--open");
    setFieldOptionsTabIndex(fieldset, false);
    const toggle = fieldset.querySelector(".filters__fieldset-toggle");
    if (toggle) {
      toggle.setAttribute("aria-expanded", "false");
    }
  };

  fieldsets.forEach(fieldset => {
    const toggle = fieldset.querySelector(".filters__fieldset-toggle");
    if (!toggle) {
      return;
    }

    toggle.addEventListener("click", function (e) {
      const isOpen = fieldset.classList.contains("filters__fieldset--open");

      fieldsets.forEach(closeFieldset);

      if (!isOpen) {
        fieldset.classList.add("filters__fieldset--open");
        setFieldOptionsTabIndex(fieldset, true);
        toggle.setAttribute("aria-expanded", "true");
      }
    });

    fieldset.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeFieldset(fieldset);
        toggle.focus();
      }
    });

    fieldset.addEventListener("focusout", function (e) {
      if (!fieldset.contains(e.relatedTarget)) {
        closeFieldset(fieldset);
      }
    });
  });

  // close dropdowns when clicking anywhere else
  document.addEventListener("click", e => {
    fieldsets.forEach(fieldset => {
      if (!fieldset.contains(e.target)) {
        closeFieldset(fieldset);
      }
    });
  });

  // on click change filter
  const filtersOptions = filters.querySelectorAll(".filters__fieldset-field input");
  filtersOptions.forEach(option => {
    option.addEventListener("change", function (evt) {
      selectFilter(this);
    });
  });

  const filterOptionLabels = filters.querySelectorAll(".filters__fieldset-field");
  filterOptionLabels.forEach(optionLabel => {
    optionLabel.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") {
        return;
      }
      e.preventDefault();
      const option = optionLabel.querySelector("input");
      if (option && !option.checked) {
        option.checked = true;
        selectFilter(option);
      }
    });
  });

  const clearBtn = filters.querySelector(".filters__clear");
  clearBtn.addEventListener("click", function (e) {
    clearFilter();
  });
};

filterInit();
